import { useDarkMode } from 'hooks/browser/mediaQueries';
import { useToggleSearch } from 'hooks/search';

import { SearchGradientIcon } from './icons/SearchGradientIcon';
import { SearchIcon } from './icons/SearchIcon';

export const SearchTrigger = () => {
  const { setActive } = useToggleSearch();
  const { isDarkMode } = useDarkMode();

  return (
    <button
      onClick={setActive}
      className="mx-3 block px-2 text-white sm:hidden"
    >
      {isDarkMode ? <SearchIcon /> : <SearchGradientIcon size={20} />}
    </button>
  );
};
